import { useTranslation } from "react-i18next"

import { Card, Input, Label } from "@f2e/ui/components/base"
import { ExtensionClientConfig } from "@/types"

export interface ExtensionConfigFieldsProps {
  config: ExtensionClientConfig
  isEditing: boolean
  onConfigChange?: (config: Partial<ExtensionClientConfig>) => void
}

export const ExtensionConfigFields = ({
  config,
  isEditing,
  onConfigChange,
}: ExtensionConfigFieldsProps) => {
  const { t } = useTranslation()
  return (
    <Card className="p-6">
      <div className="space-y-2">
        <Label htmlFor="config-extension-id">
          {t("workspace.channels.config.extension.extensionId")}
        </Label>
        <Input
          id="config-extension-id"
          value={config.extensionId}
          onChange={(e) => onConfigChange?.({ extensionId: e.target.value })}
          disabled={!isEditing}
          className="w-full font-mono text-sm"
          placeholder={t(
            "workspace.channels.config.extension.extensionIdPlaceholder"
          )}
        />
      </div>
    </Card>
  )
}

export default ExtensionConfigFields
